// Create carousel
function createLogoCarousel(numberOfSlides){
    jQuery('.logo-container').not('.slick-initialized').slick({
        dots: true,
        arrows: false,
        infinite: true,
        slidesToShow: numberOfSlides,
      	rows: 2,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 1000,
        pauseOnHover: true
    });
}

// Calculate number of slides to show
function calculateNumberOfSlidesToShow(){
    var carouselWidth = jQuery(".logo-container").width();
    var numberOfSlides = 0;
  	var numberOfRows = 0;
    switch (true) {
        case (carouselWidth < 767):
            numberOfSlides = 2;
            break;
        case (carouselWidth < 991):
            numberOfSlides = 2;
            break;
        case (carouselWidth < 1199):
            numberOfSlides = 6;
            break;
        case (carouselWidth > 1200):
            numberOfSlides = 6;
            break;
    }

    return numberOfSlides;
}

// Reload Carousel on browser resize (to make it responsible)
function reloadCarousel () {
    $('.logo-container').slick('unslick');
    numberOfSlides = calculateNumberOfSlidesToShow();
    createLogoCarousel(numberOfSlides);
}

// Call updateMaxHeight when browser resize event fires
$(window).on("resize", reloadCarousel);



$(document).ready(function () {
  
    var viewportWidth = $(window).width();
    console.log(viewportWidth);
    if( viewportWidth > 767 ){
    	$('.about-babu .image-with-text .feature-row').addClass('onlyipad');
    } else {
    	$('.about-babu .image-with-text .feature-row').removeClass('onlyipad');
    }
  if( viewportWidth > 767 ){
    	$('.our-pricing .image-with-text .feature-row').addClass('onlyipad');
    } else {
    	$('.our-pricing .image-with-text .feature-row').removeClass('onlyipad');
    }
  if( viewportWidth > 767 ){
    	$('#ourpricing+div .background-media-text__text .image').addClass('onlyipad');
    } else {
    	$('#ourpricing+div .background-media-text__text .image').removeClass('onlyipad');
    }

    // Initialize the carousel on page load
    if ($(".logo-container").length) {
        setTimeout(function () {
            numberOfSlides = calculateNumberOfSlidesToShow();
            createLogoCarousel(numberOfSlides);
        }, 300);
    }   

});

$(window).scroll(function(){
  var sticky = $('.site-header'),
      scroll = $(window).scrollTop();

  if (scroll >= 100) {
    var padding = 0;
    var header_ht = $('header.site-header.fixed').height();
    var total_ht = header_ht - padding;
  //$('.slide-nav__overflow--thumb').css('top',total_ht);
    sticky.addClass('fixed');
  }
  else {
    sticky.removeClass('fixed');
   // $('.slide-nav__overflow--thumb').css('top','115px');
  }
});
$('.js-toggle-slide-nav1 .icon-hamburger').click(function(e){
  $('.vs_drop_menu').addClass('is-transitioning')
       $(this).parent('.js-toggle-slide-nav1').addClass('active-menu');
  $('.vs_drop_menu').addClass('js-menu--is-open')
})
$('.js-toggle-slide-nav1 .icon-close').click(function(e){
     $(this).parent('.js-toggle-slide-nav1').removeClass('active-menu');
   $('.vs_drop_menu').removeClass('js-menu--is-open')
  $('.vs_drop_menu').removeClass('is-transitioning')
    $('.vs_drop_menu').removeClass('sub-nav--is-open')
})
$('.js-toggle-submenu').click(function(){
    $('.vs_drop_menu').addClass('sub-nav--is-open')
})
$('.slide-nav__table-cell.slide-nav__return').click(function(){
    $('.vs_drop_menu').removeClass('sub-nav--is-open')
})

$('.menu-button').click(function() {
  $(this).parent('.custom-click-button').toggleClass('is-focused');
});

